export default __webpack_public_path__ + "static/media/omanyala.6b40ab44.jpg";